import { setStandardSaveButtonState } from "./common.js";

let paymentReceiptsPiOptions = [];
let paymentReceiptsInvoiceOptions = [];

window.initPaymentReceipts = function initPaymentReceipts(root) {
  const scope = root || document;
  scope.querySelectorAll('[data-payment-receipts-config="1"]').forEach((config) => {
    window.paymentReceiptsSetGridLandingUrl(config);
    window.paymentReceiptsBindJobGridLoader(config);
  });

  const supplyField = scope.querySelector('[name="supply_amount"]') || document.querySelector('[name="supply_amount"]');
  const erectionField = scope.querySelector('[name="erection_amount"]') || document.querySelector('[name="erection_amount"]');
  const totalField = scope.querySelector('[name="amount"]') || document.querySelector('[name="amount"]');

  paymentReceiptsBindPaymentAgainst(scope);
  const methodField = paymentReceiptsHiddenInput('methodofa');
  if (methodField && methodField.dataset.paymentReceiptsTypeFilterBound !== '1') {
    methodField.dataset.paymentReceiptsTypeFilterBound = '1';
    methodField.addEventListener('change', paymentReceiptsRefreshDocumentOptions);
  }

  function calculateTotal() {
    const supply = supplyField ? parseFloat(supplyField.value) || 0 : 0;
    const erection = erectionField ? parseFloat(erectionField.value) || 0 : 0;
    if (!totalField) return;
    totalField.value = (supply + erection).toFixed(2);
  }

  if (supplyField && supplyField.dataset.paymentReceiptsBound !== '1') {
    supplyField.addEventListener('input', calculateTotal);
    supplyField.dataset.paymentReceiptsBound = '1';
  }

  if (erectionField && erectionField.dataset.paymentReceiptsBound !== '1') {
    erectionField.addEventListener('input', calculateTotal);
    erectionField.dataset.paymentReceiptsBound = '1';
  }

  if (supplyField && erectionField && totalField) {
    calculateTotal();
  }
};

function paymentReceiptsAgainstValue() {
  const checked = document.querySelector('[name="payment_against"]:checked');
  return checked && checked.value ? checked.value : 'Other';
}

function paymentReceiptsVirtualSelect(name) {
  return document.getElementById(name);
}

function paymentReceiptsHiddenInput(name) {
  return document.querySelector(`[name="${name}"]`);
}

function paymentReceiptsSuppressNextVirtualHtmx(el) {
  if (!el) return;
  el.setAttribute('data-vs-nohtmx', 'true');
  window.setTimeout(() => {
    if (el && el.hasAttribute('data-vs-nohtmx')) {
      el.removeAttribute('data-vs-nohtmx');
    }
  }, 250);
}

function paymentReceiptsSetVirtualValue(name, value, options) {
  const settings = options || {};
  const el = paymentReceiptsVirtualSelect(name);
  const input = paymentReceiptsHiddenInput(name);
  const rawValue = value == null ? '' : value;
  const nextValue = value == null ? '' : String(value);
  if (settings.suppressHtmx !== false) {
    paymentReceiptsSuppressNextVirtualHtmx(el);
  }
  if (el && typeof el.setValueSilently === 'function') {
    el.setValueSilently(rawValue);
  } else if (el && typeof el.setValue === 'function') {
    el.setValue(rawValue);
  }
  if (input) {
    input.value = nextValue;
    if (settings.dispatchChange !== false) {
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

function paymentReceiptsSetVirtualOptions(name, options) {
  const el = paymentReceiptsVirtualSelect(name);
  if (!el || typeof el.setOptions !== 'function') return;
  const rows = Array.isArray(options) ? options : [];
  el.setOptions(rows.map((option) => ({
    label: option.text || option.label || '',
    value: option.value == null ? '' : String(option.value),
  })));
}

function paymentReceiptsBillingType() {
  const method = String(paymentReceiptsHiddenInput('methodofa')?.value || '');
  if (method === 'Erection') return 'Erection';
  if (method === 'Supply' || method === 'Advance') return 'Supply';
  return '';
}

function paymentReceiptsFilterDocumentOptions(options) {
  const billingType = paymentReceiptsBillingType().toLowerCase();
  if (!billingType) return options;
  return (options || []).filter((option) => (
    String(option.billing_type || '').trim().toLowerCase() === billingType
  ));
}

function paymentReceiptsRefreshDocumentOptions(preservedValues) {
  [
    ['proformamaster_id', paymentReceiptsPiOptions],
    ['invoicemaster_id', paymentReceiptsInvoiceOptions],
  ].forEach(([name, options]) => {
    const current = String(
      preservedValues?.[name] ?? paymentReceiptsHiddenInput(name)?.value ?? ''
    );
    const filtered = paymentReceiptsFilterDocumentOptions(options);
    paymentReceiptsSetVirtualOptions(name, filtered);
    if (current && filtered.some((option) => String(option.value) === current)) {
      paymentReceiptsSetVirtualValue(name, current, { dispatchChange: false });
    } else if (current) {
      paymentReceiptsSetVirtualValue(name, '');
    }
  });
}

function paymentReceiptsSetVirtualDisabled(name, disabled) {
  const el = paymentReceiptsVirtualSelect(name);
  if (!el) return;
  el.dataset.disabled = disabled ? 'true' : 'false';
  if (disabled && typeof el.disable === 'function') {
    el.disable();
  } else if (!disabled && typeof el.enable === 'function') {
    el.enable();
  }
}

function paymentReceiptsAgainstWrapper(name) {
  const el = paymentReceiptsVirtualSelect(name);
  return el ? el.closest('[data-select-type="select"]') : null;
}

function paymentReceiptsToggleAgainstField(name, visible, clearValue) {
  const wrapper = paymentReceiptsAgainstWrapper(name);
  if (wrapper) {
    wrapper.classList.toggle('hidden', !visible);
  }
  paymentReceiptsSetVirtualDisabled(name, !visible);
  if (!visible && clearValue) {
    paymentReceiptsSetVirtualValue(name, '');
  }
}

function paymentReceiptsUpdateAgainstFields(clearInactive) {
  const value = paymentReceiptsAgainstValue();
  paymentReceiptsToggleAgainstField('orderterms_id', value === 'Term', clearInactive);
  paymentReceiptsToggleAgainstField('proformamaster_id', value === 'PI', clearInactive);
  paymentReceiptsToggleAgainstField('invoicemaster_id', value === 'Invoice', clearInactive);
}

function paymentReceiptsBindPaymentAgainst(scope) {
  const radios = Array.from((scope || document).querySelectorAll('[name="payment_against"]'));
  if (!radios.length) return;

  if (!radios.some((radio) => radio.checked)) {
    const other = radios.find((radio) => radio.value === 'Other');
    if (other) {
      other.checked = true;
      other.setAttribute('data-checked', 'Other');
    }
  }

  radios.forEach((radio) => {
    if (radio.dataset.paymentReceiptsAgainstBound === '1') return;
    radio.dataset.paymentReceiptsAgainstBound = '1';
    radio.addEventListener('change', () => paymentReceiptsUpdateAgainstFields(true));
  });

  paymentReceiptsUpdateAgainstFields(false);
}

function paymentReceiptsToken() {
  const urlToken = new URLSearchParams(window.location.search).get('apitoken');
  if (urlToken) return urlToken;
  const input = document.querySelector('[name="apitoken"]');
  return input ? input.value : '';
}

function paymentReceiptsAppendToken(url) {
  const token = paymentReceiptsToken();
  if (!token) return url;
  const join = url.indexOf('?') === -1 ? '?' : '&';
  return `${url}${join}apitoken=${encodeURIComponent(token)}`;
}

function paymentReceiptsParseDisplayDate(val) {
  if (!val) return '';
  const parts = String(val).trim().split('/');
  if (parts.length !== 3) return '';
  const day = parts[0].padStart(2, '0');
  const month = parts[1].padStart(2, '0');
  const year = parts[2].length === 2 ? `20${parts[2]}` : parts[2];
  return `${year}-${month}-${day}`;
}

function paymentReceiptsActionConfig() {
  const config = document.querySelector('[data-payment-receipts-config="1"]');
  return {
    canEditLocked: Boolean(config && config.dataset.canEditLocked === '1'),
  };
}

function paymentReceiptsSetSaveButtonMode(row) {
  const btn = document.getElementById('standard-save-button');
  if (!btn) return;
  const hasRecord = Boolean(row && row.id);
  const config = paymentReceiptsActionConfig();
  const isLocked = hasRecord && Boolean(row.tally_receipt_no) && !config.canEditLocked;
  const indicator = btn.querySelector('[id^="save-indicator-"]');
  btn.textContent = '';
  if (indicator) {
    btn.appendChild(indicator);
  }
  btn.appendChild(document.createTextNode(hasRecord ? 'Update' : 'Save'));
  setStandardSaveButtonState(btn, {
    disabled: isLocked,
    palette: hasRecord ? 'update' : 'save',
  });
  if (isLocked) {
    btn.title = 'You are not authorised for editing this receipt.';
  } else {
    btn.removeAttribute('title');
  }
}

function paymentReceiptsSetDeleteButtonMode(row) {
  const deleteWrap = document.getElementById('paymentreceiptsssr-dynamic-delete');
  if (!deleteWrap) return;
  const config = paymentReceiptsActionConfig();
  deleteWrap.classList.toggle('hidden', !(row && row.id && config.canEditLocked));
  if (!deleteWrap.classList.contains('hidden') && window.htmx) {
    window.htmx.process(deleteWrap);
  }
}

function paymentReceiptsSetSelectedReceipt(row) {
  const selectedRow = row && row.id ? row : null;
  const selectedId = selectedRow ? selectedRow.id : '';
  const idInput = paymentReceiptsHiddenInput('id');
  if (idInput) idInput.value = selectedId;
  const selectedInput = paymentReceiptsHiddenInput('selected_receipt_id');
  if (selectedInput) selectedInput.value = selectedId;
  paymentReceiptsSetSaveButtonMode(selectedRow);
  paymentReceiptsSetDeleteButtonMode(selectedRow);
}

window.paymentReceiptsFillFromRow = function paymentReceiptsFillFromRow(params) {
  const row = params && params.data ? params.data : null;
  if (!row) return;

  window.paymentReceiptsLastRow = row;

  paymentReceiptsSetSelectedReceipt(row);

  const dateInput = document.querySelector('[name="billdate"]');
  if (dateInput) {
    dateInput.value = row.billdate || paymentReceiptsParseDisplayDate(row.payment_date);
    dateInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  paymentReceiptsSetInputValue('billno', row.tally_receipt_no || '');
  paymentReceiptsSetInputValue('particulars', row.particulars || '');
  paymentReceiptsSetInputValue('supply_amount', row.supply_amount != null ? row.supply_amount : '');
  paymentReceiptsSetInputValue('erection_amount', row.erection_amount != null ? row.erection_amount : '');

  const gaCheckbox = document.querySelector('[name="against_ga"]');
  if (gaCheckbox) {
    gaCheckbox.checked = Boolean(row.against_ga);
    gaCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  paymentReceiptsSetVirtualValue('modeofpayment', row.mode_of_payment || '', { suppressHtmx: true });
  paymentReceiptsSetVirtualValue('methodofa', row.method_of_adj || '', { suppressHtmx: true });

  const against = row.payment_against || 'Other';
  document.querySelectorAll('[name="payment_against"]').forEach((radio) => {
    radio.checked = radio.value === against;
  });
  paymentReceiptsUpdateAgainstFields(true);
  paymentReceiptsSetVirtualValue('orderterms_id', row.orderterms_id || '');
  paymentReceiptsSetVirtualValue('proformamaster_id', row.proformamaster_id || '');
  paymentReceiptsSetVirtualValue('invoicemaster_id', row.invoicemaster_id || '');
};

window.paymentReceiptsSetGridLandingUrl = function paymentReceiptsSetGridLandingUrl(el) {
  const gridId = el ? el.dataset.gridId : '';
  const grid = gridId ? document.querySelector(`#${gridId}`) : null;
  if (grid && el.dataset.landingUrl) {
    grid.dataset.landingUrl = el.dataset.landingUrl;
  }
};

function paymentReceiptsGridApi(gridId) {
  return gridId ? window[`aggridApi:${gridId}`] || null : null;
}

function paymentReceiptsSetGridRows(gridId, rows) {
  const api = paymentReceiptsGridApi(gridId);
  if (api && typeof api.setGridOption === 'function') {
    api.setGridOption('rowData', Array.isArray(rows) ? rows : []);
  }
}

function paymentReceiptsReadJobId() {
  const input = document.querySelector('[name="orderconfirmation_id"]');
  return input && input.value ? input.value : '';
}

function paymentReceiptsSetInputValue(name, value) {
  const input = paymentReceiptsHiddenInput(name);
  if (!input) return;
  input.value = value == null ? '' : String(value);
  input.dispatchEvent(new Event('input', { bubbles: true }));
  input.dispatchEvent(new Event('change', { bubbles: true }));
}

function paymentReceiptsApplyJobContext(context, clearTargets) {
  const data = context || {};
  const preserved = clearTargets ? {} : {
    orderterms_id: String(paymentReceiptsHiddenInput('orderterms_id')?.value || ''),
    proformamaster_id: String(paymentReceiptsHiddenInput('proformamaster_id')?.value || ''),
    invoicemaster_id: String(paymentReceiptsHiddenInput('invoicemaster_id')?.value || ''),
  };
  paymentReceiptsSetVirtualValue('customer_id', data.customer_id || '', { dispatchChange: false });
  const ordertermOptions = data.orderterm_options || [];
  paymentReceiptsSetVirtualOptions('orderterms_id', ordertermOptions);
  paymentReceiptsPiOptions = data.pi_options || [];
  paymentReceiptsInvoiceOptions = data.invoice_options || [];
  paymentReceiptsRefreshDocumentOptions(preserved);
  if (clearTargets) {
    paymentReceiptsSetVirtualValue('orderterms_id', '');
    paymentReceiptsSetVirtualValue('proformamaster_id', '');
    paymentReceiptsSetVirtualValue('invoicemaster_id', '');
  } else if (
    preserved.orderterms_id
    && ordertermOptions.some(
      (option) => String(option.value) === preserved.orderterms_id
    )
  ) {
    paymentReceiptsSetVirtualValue(
      'orderterms_id',
      preserved.orderterms_id,
      { dispatchChange: false },
    );
  }
  paymentReceiptsSetInputValue('contract_value', data.contract_value ?? '');
  paymentReceiptsSetInputValue('job_id_total', data.job_id_total ?? '');
  paymentReceiptsSetInputValue('total_received', data.total_received ?? '');
  paymentReceiptsSetInputValue('balance', data.balance ?? '');
  paymentReceiptsUpdateAgainstFields(clearTargets);
}

window.paymentReceiptsBindJobGridLoader = function paymentReceiptsBindJobGridLoader(el) {
  if (!el || el.dataset.paymentReceiptsJobGridBound === '1') return;
  el.dataset.paymentReceiptsJobGridBound = '1';

  const gridId = el.dataset.gridId || '';
  const listUrl = el.dataset.listUrl || '/ssr/paymentreceiptsssr/jobreceipts/listdata';
  const jobInput = document.querySelector('[name="orderconfirmation_id"]');
  if (!gridId || !jobInput) return;

  let lastValue = el.dataset.initialJobId || jobInput.value || '';
  let requestSeq = 0;
  let controller = null;

  async function loadJobReceipts(options) {
    const settings = options || {};
    const jobId = paymentReceiptsReadJobId();
    if (!settings.force && jobId === lastValue) return;
    lastValue = jobId;
    requestSeq += 1;
    const seq = requestSeq;

    if (controller) {
      controller.abort();
    }
    controller = new AbortController();

    const api = paymentReceiptsGridApi(gridId);
    if (!jobId) {
      paymentReceiptsSetGridRows(gridId, []);
      paymentReceiptsApplyJobContext(null, true);
      return;
    }

    const url = new URL(listUrl, window.location.origin);
    url.searchParams.set('orderconfirmation_id', jobId);
    const templateInput = document.querySelector('[name="jobReceiptsGridTemplate"]');
    if (templateInput && templateInput.value) {
      url.searchParams.set('jobReceiptsGridTemplate', templateInput.value);
    }
    const token = paymentReceiptsToken();
    if (token) {
      url.searchParams.set('apitoken', token);
    }

    try {
      if (api && typeof api.setGridOption === 'function') {
        api.setGridOption('loading', true);
      }
      const response = await fetch(url.toString(), {
        method: 'GET',
        credentials: 'same-origin',
        signal: controller.signal,
      });
      if (!response.ok) {
        throw new Error(`Payment receipts grid request failed: ${response.status}`);
      }
      const payload = await response.json();
      if (seq !== requestSeq) return;
      const rows = payload && payload.get_list ? payload.get_list.result : [];
      paymentReceiptsSetGridRows(gridId, rows);
      paymentReceiptsApplyJobContext(
        payload ? payload.context : null,
        settings.preserveTargets !== true,
      );
    } catch (error) {
      if (error && error.name === 'AbortError') return;
      console.error(error);
      if (seq === requestSeq) {
        paymentReceiptsSetGridRows(gridId, []);
      }
    } finally {
      if (seq === requestSeq && api && typeof api.setGridOption === 'function') {
        api.setGridOption('loading', false);
      }
    }
  }

  if (!lastValue) {
    paymentReceiptsSetGridRows(gridId, []);
  } else {
    lastValue = '';
    loadJobReceipts({
      force: el.dataset.forceRefresh === '1',
      preserveTargets: true,
    });
  }

  jobInput.addEventListener('change', () => {
    paymentReceiptsSetSelectedReceipt(null);
    loadJobReceipts();
  });
};

window.paymentReceiptsGridPreview = function paymentReceiptsGridPreview(el) {
  if (!el || el.dataset.paymentReceiptsGridPreviewBound === '1') return;
  el.dataset.paymentReceiptsGridPreviewBound = '1';
  el.addEventListener('click', () => {
    const gridId = el.dataset.gridId;
    if (window.ag && typeof window.ag.printGrid === 'function' && gridId) {
      window.ag.printGrid(gridId);
    }
  });
};

window.prFixPrintButton = function prFixPrintButton() {
  var paymentRoot = document.getElementById('ssr-paymentreceiptsssr')
    || document.querySelector('[data-formname="paymentreceiptsssr"]');
  if (!paymentRoot) return;

  var printBtn = document.getElementById('dataform-print');
  if (printBtn && !printBtn.closest('#ssr-paymentreceiptsssr, [data-formname="paymentreceiptsssr"]')) return;
  if (!printBtn || printBtn.dataset.prPrintFixed === '1') return;
  var root = printBtn.closest('[data-formname="paymentreceiptsssr"]')
    || document.getElementById('ssr-paymentreceiptsssr');
  if (!root || !root.contains(printBtn)) return;
  printBtn.dataset.prPrintFixed = '1';

  var origOnclick = printBtn.getAttribute('onclick');
  if (!origOnclick) return;
  printBtn.removeAttribute('onclick');

  printBtn.addEventListener('click', function (e) {
    e.preventDefault();
    var idInput = root.querySelector('[name="selected_receipt_id"]')
      || root.querySelector('[name="id"]');
    var recordId = idInput ? idInput.value : '';
    if (!recordId || recordId === '0' || recordId === 'None') {
      console.error('No receipt selected for printing.');
      return;
    }
    var c = document.getElementById('print-container');
    if (!c) { c = document.createElement('div'); c.id = 'print-container'; document.body.appendChild(c); }
    c.dataset.recordId = recordId;
    c.dataset.slug = 'paymentreceiptsssr';
    try { window.__smaac_active_print_el = c; } catch (_e) { /* ignore */ }
    if (typeof window.generatePdfWeasyprint === 'function') {
      window.generatePdfWeasyprint('paymentreceiptsssr', true);
    }
  });
};

document.addEventListener('DOMContentLoaded', function () {
  window.prFixPrintButton();
  document.body.addEventListener('htmx:afterSettle', function () { window.prFixPrintButton(); });
});

window.prStripDaterangeHtmx = function prStripDaterangeHtmx(fieldset) {
  // Reports Preview daterange must NOT trigger landing reload from dataform —
  // htmx.process after removeAttribute does not reliably unbind existing
  // listeners, so we also veto any htmx request originating from these inputs.
  fieldset.querySelectorAll('select[hx-get], input[hx-get]').forEach(function (el) {
    el.removeAttribute('hx-get');
    el.removeAttribute('hx-include');
    el.removeAttribute('hx-vals');
    el.removeAttribute('hx-trigger');
    el.removeAttribute('hx-indicator');
    el.addEventListener('htmx:beforeRequest', function (evt) { evt.preventDefault(); });
    if (window.htmx) htmx.process(el);
  });

  var period = fieldset.querySelector('#period');
  var startInput = fieldset.querySelector('#start-date');
  var endInput = fieldset.querySelector('#end-date');
  var rangeUrl = fieldset.dataset.periodRangeUrl;
  if (!period || !startInput || !endInput || !rangeUrl) return;
  if (period.dataset.prPeriodBound === '1') return;
  period.dataset.prPeriodBound = '1';

  period.addEventListener('change', function () {
    var value = period.value;
    if (!value || value === 'customrange') return;
    var url = new URL(rangeUrl, window.location.origin);
    url.searchParams.set('period', value);
    var token = paymentReceiptsToken();
    if (token) url.searchParams.set('apitoken', token);
    fetch(url.toString(), { method: 'GET', credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data) return;
        if (data.start_date) startInput.value = data.start_date;
        if (data.end_date) endInput.value = data.end_date;
      })
      .catch(function (err) { console.error('Period range fetch failed:', err); });
  });
};

window.prDatewisePdf = function prDatewisePdf(btn) {
  if (!btn || btn.dataset.prBound === '1') return;
  btn.dataset.prBound = '1';

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var slug = btn.dataset.slug || 'paymentreceiptsssr';
    var tokenEl = document.querySelector('[name="apitoken"]');
    var fd = new FormData();
    if (tokenEl && tokenEl.value) fd.append('apitoken', tokenEl.value);
    document.querySelectorAll('[data-formname="' + slug + '"]').forEach(function (el) {
      var n = el.getAttribute('name');
      if (n && !fd.has(n)) fd.append(n, el.value || '');
    });
    var periodEl = document.getElementById('period');
    if (periodEl && !fd.has('period')) fd.append('period', periodEl.value || '');

    window.setPrintButtonLoading?.(btn, true);
    fetch('/ssr/' + slug + '/dataform/datewisepdf', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.blob();
      })
      .then(function (blob) {
        if (!blob) return;
        if (typeof window.showPreview === 'function') {
          window.showPreview(blob, 'Payment Receipts Details');
        }
      })
      .catch(function (err) {
        console.error('Datewise PDF failed:', err);
      })
      .finally(function () { window.setPrintButtonLoading?.(btn, false); });
  });
};

window.prInvoiceStatusPdf = function prInvoiceStatusPdf(btn) {
  if (!btn || btn.dataset.prBound === '1') return;
  btn.dataset.prBound = '1';

  var exitBtn = document.getElementById('paymentreceiptsssr-back-button')
    || document.getElementById('dataform-backButton');
  if (exitBtn && exitBtn.parentNode) {
    exitBtn.parentNode.insertBefore(btn, exitBtn);
  }

  btn.classList.add('hidden');
  var jobInput = document.querySelector('[name="orderconfirmation_id"]');
  function toggleVisibility() {
    var hasJob = jobInput && jobInput.value && jobInput.value !== '0' && jobInput.value !== '';
    btn.classList.toggle('hidden', !hasJob);
  }
  if (jobInput) {
    jobInput.addEventListener('change', toggleVisibility);
    toggleVisibility();
  }

  btn.addEventListener('click', function () {
    var tokenEl = document.querySelector('[name="apitoken"]');
    var fd = new FormData();
    if (tokenEl && tokenEl.value) fd.append('apitoken', tokenEl.value);
    var invoiceStatusPdfUrl = btn.dataset.invoiceStatusPdfUrl || '/ssr/paymentreceiptsssr/dataform/invoicestatuspdf';
    window.setPrintButtonLoading?.(btn, true);
    fetch(invoiceStatusPdfUrl, { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.blob();
      })
      .then(function (blob) {
        if (typeof window.showPreview === 'function') {
          window.showPreview(blob, 'Status of Invoicing');
        }
      })
      .catch(function (err) {
        console.error('Invoice status PDF failed:', err);
      })
      .finally(function () { window.setPrintButtonLoading?.(btn, false); });
  });
};
